// extracted by mini-css-extract-plugin
module.exports = {"container":"ContributeBanner_container__4I0xT","button":"ContributeBanner_button__Waj7g","flex1":"ContributeBanner_flex1__B_wT7"};